import { createUiIdContext } from '../../contexts/ElementIdContext';

const loginElementIDs = {
  btnLogin: 'btnLogin',
  inputEmail: 'inputEmail',
  inputPassword: 'inputPassword',
  selectStaging: 'selectStaging',
  optionStaging: 'optionStaging',
};

export const { ElementIdProvider, useElementIdContext } =
  createUiIdContext(loginElementIDs);
